/* ------------------------------------------------------------------
   LÉMEIN — fold the product description into Zara-style accordions.

   Descriptions are authored as exactly three paragraphs:
     1  the hook            -> stays visible
     2  the composition     -> COMPOSITION
     3  the care            -> CARE

   Anything that does not match that shape is left completely alone, so
   a product written differently later simply keeps the flat layout.
------------------------------------------------------------------- */
(function () {
  'use strict';

  function fold(prose) {
    if (!prose || prose.dataset.lmFolded === '1') return;

    var kids = Array.prototype.filter.call(prose.children, function (n) {
      return n.tagName === 'P' && n.textContent.trim() !== '';
    });
    if (kids.length !== prose.children.length || kids.length !== 3) return;

    prose.dataset.lmFolded = '1';

    [['Composition', kids[1]], ['Care', kids[2]]].forEach(function (pair) {
      var d = document.createElement('details');
      d.className = 'lm-detail';

      var s = document.createElement('summary');
      s.textContent = pair[0];
      d.appendChild(s);

      var body = document.createElement('div');
      body.className = 'lm-detail__body';
      prose.removeChild(pair[1]);
      body.appendChild(pair[1]);
      d.appendChild(body);

      prose.appendChild(d);
    });
  }

  function run() {
    document.querySelectorAll('.product-info .prose').forEach(fold);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* the buy panel re-renders on variant change, so fold again after it */
  document.addEventListener('variant:change', run);
  document.addEventListener('product:rerender', run);
})();
